var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",class:{'divider': _vm.showDivider}},[_vm._v("Version "+_vm._s(_vm.version)+". Copyright © "+_vm._s(_vm.copyrightOwner)+" "+_vm._s(_vm.year)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }